import { createSlice } from "@reduxjs/toolkit";

import {
  updateUser,
  getUsers,
  addUser,
  deleteUser,
  getUserById,
} from "./thunk";

interface UserStateType {
  users: Array<any>;
  user: any;
  error?: string | object | null | undefined | unknown;
  success?: string | object | null | undefined | unknown;
  updateSuccess?: string | object | null | undefined | unknown;
  deleteSuccess?: string | object | null | undefined | unknown;
}

export const initialState: UserStateType = {
  users: [],
  user: null,
  error: null,
  success: null,
  updateSuccess: null,
  deleteSuccess: null,
};

const userSlice = createSlice({
  name: "users",
  initialState,
  reducers: {
    userError(state, action) {
      state.error = action.payload;
    },
    userSuccess(state, action) {
      state.success = action.payload;
    },
    updateUserSuccess(state, action) {
      state.updateSuccess = action.payload;
    },
    deleteUserSuccess(state, action) {
      state.deleteSuccess = action.payload;
    },
    resetUpdateSuccess(state) {
      state.updateSuccess = null;
    },
    resetDeleteSuccess(state) {
      state.deleteSuccess = null;
    },
    resetUser(state) {
      state.user = null;
    },
  },
  extraReducers: builder => {
    builder.addCase(getUsers.fulfilled, (state: any, action: any) => {
      state.users = action.payload;
    });
    builder.addCase(getUsers.rejected, (state, action) => {
      state.error = action.payload || null;
    });
    builder.addCase(getUserById.fulfilled, (state: any, action: any) => {
      state.user = action.payload;
    });
    builder.addCase(getUserById.rejected, (state, action) => {
      state.error = action.payload || null;
    });
    builder.addCase(addUser.fulfilled, (state: any, action: any) => {
      state.users.push(action.payload);
    });
    builder.addCase(addUser.rejected, (state, action) => {
      state.error = action.payload || null;
    });
    builder.addCase(updateUser.fulfilled, (state: any, action: any) => {
      state.users = state.users.map((user: any) =>
        user.id === action.payload.id ? { ...user, ...action.payload } : user
      );
    });
    builder.addCase(updateUser.rejected, (state, action) => {
      state.error = action.payload || null;
    });
    builder.addCase(deleteUser.fulfilled, (state: any, action: any) => {
      state.users = state.users.filter(
        (user: any) => user.id !== action.payload
      );
    });
    builder.addCase(deleteUser.rejected, (state, action) => {
      state.error = action.payload || null;
    });
  },
});

export const {
  userError,
  userSuccess,
  updateUserSuccess,
  deleteUserSuccess,
  resetUpdateSuccess,
  resetDeleteSuccess,
  resetUser,
} = userSlice.actions;

export default userSlice.reducer;
